import CheckoutContainer from '@containers/checkout';
import useCart from '@hooks/useCart';
import usePopup from '@hooks/usePopup';
import { useTranslation } from 'react-i18next';
import { PiHandbagSimpleBold } from 'react-icons/pi';
import styles from './main.module.scss';

export default function HeaderCart() {
  const { calculateMenuCount } = useCart();
  const { openPopup, openAlert } = usePopup();
  const { t } = useTranslation('panther');
  const menuCount = calculateMenuCount();

  const handleOpenCart = () => {
    if (menuCount === 0) {
      openAlert({
        description: '' + t('empty_cart_message'),
        isConfirmButtonShow: false,
        cancelButtonText: '' + t('common:close'),
      });

      return;
    }
    openPopup(
      {
        id: 'cart',
        isOpen: true,
        Component: CheckoutContainer,
        type: 'drawer',
        props: {},
        popupOptions: {
          size: 'full',
          blockScrollOnMount: false,
          placement: 'bottom',
        },
      },
      { queryId: 'cart' },
    );
  };
  return (
    <div className="relative cursor-pointer" onClick={handleOpenCart}>
      <PiHandbagSimpleBold size="20" />
      {menuCount > 0 && (
        <span
          className={`absolute bottom-[-4px] right-[-6px] text-[10px] text-center ${styles.cartCount}`}
        >
          {menuCount}
        </span>
      )}
    </div>
  );
}
